import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { IRequestService } from '../../../services';

class CancelRequestsController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    public get cancellers(): angular.IDeferred<void>[] {
        return this._requestService.cancellers;
    }

    static $inject = [
        'requestService'
    ];
    constructor(private _requestService: IRequestService) {
    }

    cancelOutstandingRequests() {
        this._requestService.cancelPendingRequest();
    }
}

export const wtCancelRequests: ComponentDefinition = {
    componentId: 'wtCancelRequests',
    controller: CancelRequestsController,
    template: require('./cancelRequests.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
